export default __webpack_public_path__ + "6c47923e3f9623eb530cbc66985c09bb.jpg";